import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RequestStatus} from '../../utils/Enums';
import {apiClient} from '../../utils/ApiClient';
import DLog from "../../models/Dlog";

interface EmailsState {
    logs: DLog[];
    getLogsStatus: RequestStatus;
}

const initialState: EmailsState = {
    logs: [],
    getLogsStatus: RequestStatus.Idle
};

export const getDlogs = createAsyncThunk(
    'getDlogs/getDlogs',
    async ({timeFrom, timeTo}: { timeFrom: string; timeTo: string; }, {rejectWithValue}) => {
        const url = `logs/d?timeFrom=${timeFrom}&timeTo=${timeTo}`;
        const response = await apiClient.get(url);
        return response.data;
    }
);

const dlogsSlice = createSlice({
    name: 'dlogs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDlogs.pending, (state) => {
                state.getLogsStatus = RequestStatus.Loading;
            })
            .addCase(getDlogs.fulfilled, (state, action) => {
                state.getLogsStatus = RequestStatus.Success;
                state.logs = action.payload;
            })
            .addCase(getDlogs.rejected, (state, action) => {
                state.getLogsStatus = RequestStatus.Failed;
            });
    },
});

export default dlogsSlice.reducer;